export default (theme) => ({
  container: { margin: theme.spacing(2) },
  tableCell: {
    paddingTop: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    marginRight: theme.spacing(2),
    minWidth: 50,
    textAlign: 'center',
  },
});
